export default defineNuxtPlugin(() => {
    const cookie = useCookie('timezone');
    const currentTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Set the cookie if missing or if timezone has changed since last visit
    if (!cookie.value || cookie.value !== currentTz) {
        cookie.value = currentTz;
    }
});